/* eslint-disable jsx-a11y/anchor-is-valid */
import { Text, View } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

const currentYear = new Date().getFullYear();

function Copyright() {
  return (
    <View
      style={{
        ...styles.copyright,
      }}
    >
      <Text style={{ marginRight: 4 }}>{'\u00A9'}</Text>
      <Text>{`${currentYear} NorthStandard. All rights reserved.`}</Text>
    </View>
  );
}

export default Copyright;
